import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="none"
        style={{ overflow: 'visible', ...props.style }}
        {...props}
    >
        <rect width="16" height="16" fill="white" fillOpacity="0.01" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.00784 0.649284C8.5528 -0.114215 7.4471 -0.114215 6.99205 0.649285L0.171874 12.0925C-0.294261 12.8746 0.269288 13.8666 1.17977 13.8666H14.8201C15.7306 13.8666 16.2941 12.8746 15.828 12.0925L9.00784 0.649284ZM7.90832 1.19538C7.94969 1.12597 8.05021 1.12597 8.09158 1.19538L14.9117 12.6387C14.9542 12.7097 14.9029 12.7999 14.8201 12.7999H1.17977C1.09701 12.7999 1.04577 12.7097 1.08814 12.6387L7.90832 1.19538ZM7.28198 4.78512C7.26631 4.37778 7.5923 4.03901 7.99995 4.03901C8.4076 4.03901 8.73358 4.37778 8.71792 4.78513L8.55377 9.05275C8.54233 9.35034 8.29776 9.58568 7.99995 9.58568C7.70214 9.58568 7.45756 9.35034 7.44612 9.05275L7.28198 4.78512ZM8.79983 11.1743C8.79983 11.6161 8.44166 11.9743 7.99983 11.9743C7.558 11.9743 7.19983 11.6161 7.19983 11.1743C7.19983 10.7325 7.558 10.3743 7.99983 10.3743C8.44166 10.3743 8.79983 10.7325 8.79983 11.1743Z"
            fill="currentColor"
        />
    </svg>
);

export { SvgComponent as ExclamationTriangleIcon };
